import { render, staticRenderFns } from "./Pbb.vue?vue&type=template&id=31e7f330&"
import script from "./Pbb.vue?vue&type=script&lang=js&"
export * from "./Pbb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports